var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39763 9.81159C8.78815 10.2021 9.42131 10.2021 9.81184 9.81159C10.2024 9.42106 10.2024 8.7879 9.81184 8.39737L8.39763 9.81159ZM2.26937 0.854901C1.87884 0.464377 1.24568 0.464377 0.855153 0.854901C0.464629 1.24543 0.464629 1.87859 0.855153 2.26911L2.26937 0.854901ZM9.81184 2.26911C10.2024 1.87859 10.2024 1.24543 9.81184 0.854901C9.42131 0.464377 8.78815 0.464377 8.39763 0.854901L9.81184 2.26911ZM0.855153 8.39737C0.464629 8.7879 0.464629 9.42106 0.855153 9.81159C1.24568 10.2021 1.87884 10.2021 2.26937 9.81159L0.855153 8.39737ZM9.81184 8.39737L2.26937 0.854901L0.855153 2.26911L8.39763 9.81159L9.81184 8.39737ZM8.39763 0.854901L0.855153 8.39737L2.26937 9.81159L9.81184 2.26911L8.39763 0.854901Z",
    fill: "#001854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.e5bf48418059bc1d5fdd270d9badbf2c.svg";
export { ForwardRef as ReactComponent };